'use strict';

exports.__esModule = true;
exports.IMAGE_SIZE = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _env = require('./util/env');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var IMAGE_SIZE = exports.IMAGE_SIZE = {
  FULL: 'full',
  LARGE: 'large',
  MEDIUM_LARGE: 'medium_large',
  MEDIUM: 'medium',
  SMALL: 'small',
  THUMBNAIL: 'thumbnail',
  ORIGINAL: 'original'
};
var IMAGE_SIZE_MAP = [IMAGE_SIZE.THUMBNAIL, IMAGE_SIZE.SMALL, IMAGE_SIZE.MEDIUM, IMAGE_SIZE.MEDIUM_LARGE, IMAGE_SIZE.LARGE, IMAGE_SIZE.ORIGINAL, IMAGE_SIZE.FULL];

var getSrcBySize = function getSrcBySize(imageModel, size) {
  if (!imageModel) return false;
  var sizes = imageModel.sizes,
      src = imageModel.src;
  var isSVG = src.indexOf('.svg') !== -1;
  var sizeSrc = null;

  if (size && !isSVG && sizes && sizes[size]) {
    sizeSrc = sizes[size].source_url;
  } else if (size && sizes && !sizes[size]) {
    // use a larger image, if possible
    var idx = IMAGE_SIZE_MAP.indexOf(size) + 1;

    while (idx <= IMAGE_SIZE_MAP.length) {
      if (size && sizes && sizes[IMAGE_SIZE_MAP[idx]]) {
        sizeSrc = sizes[IMAGE_SIZE_MAP[idx]].source_url;
        break;
      }

      idx++;
    }

    if (!sizeSrc) {
      console.warn('Media does not exist at specified size (' + size + ') or any larger size', imageModel);
    }
  }

  return sizeSrc || src;
};

var Image = function Image(_ref) {
  var imageModel = _ref.data,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? IMAGE_SIZE.MEDIUM : _ref$size,
      noSrcSet = _ref.noSrcSet,
      withCaption = _ref.withCaption,
      remaining = _objectWithoutProperties(_ref, ['data', 'size', 'noSrcSet', 'withCaption']);

  if (!imageModel || !imageModel.src) {
    return false;
  } else if (typeof imageModel === 'number') {
    if (imageModel !== 0) {
      // WP returns 0 in case there's no image
      console.error('Image component only accepts image objects, number passed');
    }

    return false;
  }

  var srcSet = imageModel.srcSet,
      alt = imageModel.alt,
      mediaType = imageModel.mediaType,
      focus = imageModel.focus;
  var src = mediaType === 'video' ? imageModel.src : getSrcBySize(imageModel, size);
  var condProps = {
    alt: alt
  };

  if (alt.length === 0) {
    condProps.alt = '';
    condProps.role = 'presentation';
  }

  if (srcSet) {
    condProps.srcSet = srcSet;

    if (!(0, _env.isProduction)() && !imageModel.sizes) {
      delete condProps.srcSet;
      console.warn('<Image> had srcSet, but no sizes attribute.\nRemoving srcSet to avoid loading the largest possible image.\nAdd sizes attribute to suppress this warning, or add prop \'noSrcSet={true}\' to the <Image> to disable srcSet entirely.');
    }
  }

  if (noSrcSet) {
    delete condProps.srcSet;
  }

  if (mediaType === 'video') {
    var figureClassName = remaining.figureClassName,
        rest = _objectWithoutProperties(remaining, ['figureClassName']);

    return _react2.default.createElement(_reactLazyload2.default, {
      offset: 500,
      once: true
    }, _react2.default.createElement('video', _extends({
      muted: true,
      playsinline: true,
      autoPlay: true,
      loop: true
    }, rest), ' ', _react2.default.createElement('source', {
      src: src
    })));
  }

  if (focus) {
    remaining.style = {
      objectPosition: focus[0] + '% ' + focus[1] + '%'
    };
  }

  if (withCaption && imageModel.caption) {
    var _figureClassName = remaining.figureClassName,
        _rest = _objectWithoutProperties(remaining, ['figureClassName']);

    var caption = imageModel.caption,
        copyright = imageModel.copyright; // eslint-disable-next-line jsx-a11y/alt-text

    var img = _react2.default.createElement('img', _extends({
      src: src
    }, condProps, _rest));

    return _react2.default.createElement('figure', {
      className: _figureClassName
    }, _react2.default.createElement(_reactLazyload2.default, {
      offset: 200,
      once: true
    }, img), _react2.default.createElement('figcaption', null, caption), copyright && _react2.default.createElement('div', {
      className: 'copyright'
    }, copyright));
  } // eslint-disable-next-line jsx-a11y/alt-text


  return _react2.default.createElement(_reactLazyload2.default, {
    offset: 200,
    once: true
  }, _react2.default.createElement('img', _extends({
    src: src
  }, condProps, remaining)));
};

Image.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number, _propTypes2.default.bool]),
  size: _propTypes2.default.string,
  noSrcSet: _propTypes2.default.bool,
  withCaption: _propTypes2.default.bool
} : {};
exports.default = Image;